import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing, colors } = theme.busbud;
  return {
    textDivider: {
      "&::after": {
        borderTop: `1px solid ${colors.border.primary.opaque}`,
        content: "''",
        width: `calc(100% + ${spacing(7)})`,
        display: "block",
        marginLeft: spacing(-3.5),
        marginTop: spacing(3)
      }
    },
    content: {
      margin: spacing(0, 1.5)
    },
    totalContainer: {
      marginBottom: spacing(2)
    }
  };
});
